import { render, staticRenderFns } from "./CommodityTable.vue?vue&type=template&id=0c839f56&scoped=true&"
import script from "./CommodityTable.vue?vue&type=script&lang=js&"
export * from "./CommodityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c839f56",
  null
  
)

export default component.exports